import React, { useState, useEffect } from 'react';
import MembershipServiceListServices from '../../services/MembershipServiceListServices';

function UpdateMembershipService({ membership, closeModal, onSuccess }) {

  const [formValues, setFormValues] = useState({
    serviceId: '',
    membershipId: '',
    maxOrdersPerDay: '',
    maxDiscountPerOrder: '',
    discountPercent: ''
  });

  const [services, setServices] = useState([]);
  const [memberships, setMemberships] = useState([]);

  useEffect(() => {
    fetchDropdownData();
  }, []);

  const fetchDropdownData = async () => {
    try {
      const serviceRes = await MembershipServiceListServices.getServiceGuest();
      const membershipRes = await MembershipServiceListServices.getMembershipGuest();

      setServices(serviceRes?.data || []);
      setMemberships(membershipRes?.data || []);
    } catch (error) {
      console.error("Dropdown error:", error);
    }
  };

  useEffect(() => {
    if (membership) {
      setFormValues({
        serviceId: membership?.serviceId?._id || membership?.serviceId || '',
        membershipId: membership?.membershipId?._id || membership?.membershipId || '',
        maxOrdersPerDay: membership?.rules?.maxOrdersPerDay || '',
        maxDiscountPerOrder: membership?.rules?.maxDiscountPerOrder || '',
        discountPercent: membership?.rules?.discountPercent || ''
      });
    }
  }, [membership]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };

  const handleNumberInput = (e) => {
    if (['e', 'E', '+', '-', '.'].includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formValues.serviceId || !formValues.membershipId) {
      alert("Please select Service and Membership");
      return;
    }

    try {
      const payload = {
        serviceId: formValues.serviceId,
        membershipId: formValues.membershipId,
        rules: {
          maxOrdersPerDay: Number(formValues.maxOrdersPerDay),
          maxDiscountPerOrder: Number(formValues.maxDiscountPerOrder),
          discountPercent: Number(formValues.discountPercent)
        }
      };

      await MembershipServiceListServices.updateMembershipsService(
        membership._id,
        payload
      );

      alert("Membership Service Updated Successfully");
      onSuccess();
      closeModal();

    } catch (error) {
      console.error("Update Error:", error);
      alert("Failed to update Membership Service");
    }
  };

  return (
    <div className="modal fade edit-box show d-block" id="editModal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"> Edit Membership</h5>
            <button type="button" className="btn-close" onClick={closeModal} />
          </div>

          <div className="modal-body">
            <div className="container-box px-5">
              <div className="page-details">
                <form onSubmit={handleSubmit}>
                  <div className="row">

                    {/* Service Dropdown */}
                    <div className="input-field">
                      <label>Select Service *</label>
                      <select
                        name="serviceId"
                        value={formValues.serviceId}
                        onChange={handleInputChange}
                        className="form-control"
                      >
                        <option value="">Select Service</option>
                        {services.map(service => (
                          <option key={service._id} value={service._id}>
                            {service.title}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Membership Dropdown */}
                    <div className="input-field">
                      <label>Select Membership *</label>
                      <select
                        name="membershipId"
                        value={formValues.membershipId}
                        onChange={handleInputChange}
                        className="form-control"
                      >
                        <option value="">Select Membership</option>
                        {memberships.map(mem => (
                          <option key={mem._id} value={mem._id}>
                            {mem.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Max Orders */}
                    <div className="input-field">
                      <label>Max Orders Per Day *</label>
                      <input
                        type="number"
                        name="maxOrdersPerDay"
                        value={formValues.maxOrdersPerDay}
                        onChange={handleInputChange}
                        onKeyDown={handleNumberInput}
                        className="form-control"
                        min="0"
                      />
                    </div>

                    {/* Max Discount */}
                    <div className="input-field">
                      <label>Max Discount Per Order *</label>
                      <input
                        type="number"
                        name="maxDiscountPerOrder"
                        value={formValues.maxDiscountPerOrder}
                        onChange={handleInputChange}
                        onKeyDown={handleNumberInput}
                        className="form-control"
                        min="0"
                      />
                    </div>

                    {/* Discount Percent */}
                    <div className="input-field">
                      <label>Discount Percent *</label>
                      <input
                        type="number"
                        name="discountPercent"
                        value={formValues.discountPercent}
                        onChange={handleInputChange}
                        onKeyDown={handleNumberInput}
                        className="form-control"
                        min="0"
                        max="100"
                      />
                    </div>

                  </div>

                  <button className="submit-green-btn">Submit</button>
                </form>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default UpdateMembershipService;